import { render, staticRenderFns } from "./invest_qrcode.vue?vue&type=template&id=88a24c02&scoped=true&"
import script from "./invest_qrcode.vue?vue&type=script&lang=js&"
export * from "./invest_qrcode.vue?vue&type=script&lang=js&"
import style0 from "./invest_qrcode.vue?vue&type=style&index=0&id=88a24c02&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a24c02",
  null
  
)

export default component.exports